import { FunctionComponent } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import SkeletonTiles from './SkeletonTiles'

export const ClarilisLinkSkeleton:FunctionComponent = () => (
  <div className='flex justify-center items-center grow-1 h6 mv8 bg-white no-underline bb-thick b--white'>
    <Skeleton variant='text' width={100} />
  </div>
)

const PrecedentsTiledMenuSkeleton:FunctionComponent<PrecedentsTiledMenuSkeletonProps> = ({ windowHeight, headerHeight }) => (
  <div
    className='overflow-y-auto scrolling-container bg-ghost-grey'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='pb9'>
      <div className='layout-width-constraint'>
        <ClarilisLinkSkeleton />
        <nav>
          <SkeletonTiles tileCount={28} />
        </nav>
      </div>
    </div>
  </div>
)
interface PrecedentsTiledMenuSkeletonProps {
  windowHeight?: number;
  headerHeight?: number;
}

export default PrecedentsTiledMenuSkeleton
